import React from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import moment from "moment";

// Actions
import {
  resetError,
  FetchUpdateAdminBuyProcDelvy
} from "actions/spendActions";

class AdminBuyProcDelvy extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      data: [],
      edited: [],
      responseMessage: "",
      isError: false
    };

    this.loadData = this.loadData.bind(this);
  }

  componentDidMount() {
    this.loadData();
  }

  loadData() {
    const request = {
      Read_Write_Flag: "R",
      UserId: this.props.user.user.Email,
      Admin_BuyProcDelvy_List: []
    };

    this.props.FetchUpdateAdminBuyProcDelvy(request).then((response) => {
      if (response.status === 200 && Array.isArray(response.data.Result)) {
        const normalized = response.data.Result.map((r) => ({
          ...r,
          GOOD_RECEIPT_PER_PO:
            r.GOOD_RECEIPT_PER_PO === "Yes" ? "Yes" : "No",
          ADV_SHIP_NOTICE_PER_PO:
            r.ADV_SHIP_NOTICE_PER_PO === "Yes" ? "Yes" : "No"
        }));
        this.setState({ data: normalized });
      }
    });
  }

  trackChanges = (record) => {
    let updated = [...this.state.edited];
    let index = updated.findIndex(
      (x) => x.BUY_PROCESS_DELIVER_ID === record.BUY_PROCESS_DELIVER_ID
    );

    if (index > -1) {
      updated[index] = record;
    } else {
      updated.push(record);
    }

    this.setState({
      edited: updated,
      responseMessage: "",
      isError: false
    });
  };

  onSave = () => {
    this.setState({ isLoading: true, responseMessage: "", isError: false });

    const payload = {
      Read_Write_Flag: "W",
      UserId: this.props.user.user.Email,
      Admin_BuyProcDelvy_List: this.state.edited.map((item) => {
        const original = this.state.data.find(
          (r) => r.BUY_PROCESS_DELIVER_ID === item.BUY_PROCESS_DELIVER_ID
        ) || {};

        return {
          BUY_PROCESS_DELIVER_ID: item.BUY_PROCESS_DELIVER_ID,
          PRIMARY_BUY_PROCESS_DELIVERED:
            item.PRIMARY_BUY_PROCESS_DELIVERED ||
            original.PRIMARY_BUY_PROCESS_DELIVERED,
            GR_PER_PO:
            item.GOOD_RECEIPT_PER_PO ||
            original.GOOD_RECEIPT_PER_PO ||
            "No",
            ASN_PER_PO:
            item.ADV_SHIP_NOTICE_PER_PO ||
            original.ADV_SHIP_NOTICE_PER_PO ||
            "No",
          USER_ID: this.props.user.user.Email
        };
      })
    };

    this.props
      .FetchUpdateAdminBuyProcDelvy(payload)
      .then((response) => {
        if (response.status === 200 && Array.isArray(response.data.Result)) {
          const normalized = response.data.Result.map((r) => ({
            ...r,
            GOOD_RECEIPT_PER_PO:
              r.GOOD_RECEIPT_PER_PO === "Yes" ? "Yes" : "No",
            ADV_SHIP_NOTICE_PER_PO:
              r.ADV_SHIP_NOTICE_PER_PO === "Yes" ? "Yes" : "No"
          }));
          this.setState({
            data: normalized,
            edited: [],
            isLoading: false,
            responseMessage: "Saved successfully",
            isError: false
          });
        } else {
          this.setState({
            isLoading: false,
            responseMessage: "Save failed",
            isError: true
          });
        }
      })
      .catch(() => {
        this.setState({
          isLoading: false,
          responseMessage: "Save failed",
          isError: true
        });
      });
  };

  componentWillUnmount() {
    this.props.resetError();
  }

  render() {
    return (
      <div style={{ width: "100%" }}>
        <div className="grid-x">
          <div className="medium-12">
            {this.state.isLoading && (
              <img
                style={{ display: "block", marginLeft: "auto", marginRight: "auto" }}
                src="images/ajax-loader.gif"
                alt="loading"
              />
            )}

            {this.state.data.length > 0 && (
              <div>
                <div className="grid-x">
                  <div
                    className="medium-6 float-left"
                    style={{ fontSize: "1.2rem", paddingBottom: "8px" }}
                  >
                    {"Goods Receipt & Advanced Ship Notice Calculation Parameters"}
                  </div>
                  <div
                    className="medium-6"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <div
                      style={{
                        margin: "0 0 0.5rem",
                        color: this.state.isError ? "red" : "#4fb81c"
                      }}
                    >
                      {this.state.responseMessage}
                    </div>
                  </div>
                </div>

                <div className="grid-x">
                  {this.props.user.userprofile.Roles[0].indexOf("Admin") > -1 && (
                    <div className="medium-12" style={{ paddingBottom: "2px" }}>
                      <button
                        className={classNames("float-right", {
                          "hand-cursor": this.state.edited.length > 0,
                          "gray-scale": this.state.edited.length === 0
                        })}
                        onClick={this.onSave}
                        disabled={
                          this.state.isLoading || this.state.edited.length === 0
                        }
                        type="submit"
                      >
                        <img
                          width="25"
                          title="Save"
                          src="images/save_active.svg"
                          alt="Save"
                        />
                      </button>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>

        {this.state.data.length > 0 && (
          <div className="grid-x">
            <div className="medium-12">
              <table className="basic-table">
                <thead>
                  <tr className="eachRow">
                    <th>Primary SAP Ariba Buy Process - Deliver</th>
                    <th>Good Receipt Per PO</th>
                    <th>Advance Ship Notice Per PO</th>
                    <th>Updated By</th>
                    <th>Updated Date</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.data.map((row) => (
                    <TableRow
                      key={row.BUY_PROCESS_DELIVER_ID}
                      row={row}
                      trackChanges={this.trackChanges}
                    />
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    );
  }
}

class TableRow extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      gr: props.row.GOOD_RECEIPT_PER_PO === "Yes",
      asn: props.row.ADV_SHIP_NOTICE_PER_PO === "Yes"
    };
  }

  handleToggle = (field) => (e) => {
    const checked = e.target.checked;
    const newVal = checked ? "Yes" : "No";

    this.setState({ [field]: checked });

    const updated = {
      ...this.props.row,
      GOOD_RECEIPT_PER_PO:
        field === "gr" ? newVal : (this.state.gr ? "Yes" : "No"),
      ADV_SHIP_NOTICE_PER_PO:
        field === "asn" ? newVal : (this.state.asn ? "Yes" : "No")
    };

    this.props.trackChanges(updated);
  };

  render() {
    const { row } = this.props;

    return (
      <tr className="eachRow">
        <td>{row.PRIMARY_BUY_PROCESS_DELIVERED}</td>
        <td style={{ textAlign: "center" }}>
          <input
            type="checkbox"
            checked={this.state.gr}
            onChange={this.handleToggle("gr")}
          />
        </td>
        <td style={{ textAlign: "center" }}>
          <input
            type="checkbox"
            checked={this.state.asn}
            onChange={this.handleToggle("asn")}
          />
        </td>
        <td>{row.USER_ID}</td>
        <td>{row.DATA_LOAD_DT ? moment(row.DATA_LOAD_DT).format("L") : "-"}</td>
      </tr>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.default,
  content: state.content.menu.EnablementParametersManager[0].FieldVisibilityTab
});

const mapDispatchToProps = (dispatch) => ({
  resetError: () => dispatch(resetError()),
  FetchUpdateAdminBuyProcDelvy: (data) =>
    dispatch(FetchUpdateAdminBuyProcDelvy(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminBuyProcDelvy);
